import { ActionButton } from "@lib/components/MiniComponents/Buttons";
import TableIdButton from "@lib/components/MiniComponents/Buttons/TableIdButton";
import ProviderName from "@lib/components/MiniComponents/Others/ProviderName";
import { StyledFlex } from "@lib/components/MiniComponents/Table/index.styled";
import { shortenString } from "@lib/helpers/StringHelper";
import { ColumnConfig, generateColumns } from "@lib/helpers/TableHelper";
import { AuthRoles, ProviderTransactionConfig } from "@lib/types";
import { UseMutationProps } from "@lib/types/Api";
import { TableColumnsProps } from "@lib/types/General";
import { ColumnsType } from "antd/es/table";
import dayjs from "dayjs";

type Props<T> = TableColumnsProps<T> & {
  openModal: boolean;
  handleSelect?: (item: T) => void;
  deleteQuery?: UseMutationProps<Pick<ProviderTransactionConfig, "id">>;
};

const getColumns = <T extends ProviderTransactionConfig>(
  props: Props<T>,
): ColumnsType<T> => {
  const {
    // openModal,
    handleSelect,
    deleteQuery,
    userRole,
    // messages,
  } = props;

  const columnsConfig: ColumnConfig<T>[] = [
    {
      title: "ID",
      dataIndex: "id",
      width: "160px",
      render: (value) => (
        <TableIdButton
          text={`${shortenString(value)}`}
          textToBeCopied={value}
        />
      ),
      filterType: "search",
    },

    {
      title: "common.name",
      dataIndex: "name",
      filterType: "search",
      width: "180px",
    },

    {
      title: "common.provider",
      dataIndex: "provider",
      render: (v, r) => <ProviderName provider={r?.provider} link />,
      hiddenByRole: [AuthRoles.CustomerAgent, AuthRoles.ProviderAgent],
      userRole: userRole,
      filterType: "search",
      width: "220px",
    },
    {
      title: "common.currency",
      dataIndex: "currency",
      filterType: "search",
      width: "150px",
    },
    {
      title: "common.from",
      dataIndex: "from",
      filterType: "search",
      width: "150px",
    },
    {
      title: "common.to",
      dataIndex: "to",
      filterType: "search",
      width: "150px",
    },
    {
      title: "common.dailyLimit",
      dataIndex: "dailyLimit",
      filterType: "search",
      width: "200px",
    },
    {
      title: "common.dailyTotal",
      dataIndex: "dailyTotal",
      filterType: "search",
      width: "200px",
    },
    {
      title: "common.lastUsedAt",
      dataIndex: "lastUsedAt",
      filterType: "search",
      width: "200px",
      render: (d) => dayjs(d).fromNow(),
    },
    {
      title: "common.createdAt",
      dataIndex: "createdAt",
      width: "180px",
    },
    {
      title: "common.createdBy",
      dataIndex: "createdBy",
      width: "180px",
      hiddenByRole: [AuthRoles.CustomerAgent, AuthRoles.ProviderAgent],
      userRole: userRole,
    },
    {
      title: "common.actions",
      dataIndex: "actions",
      className: "order-table-action",
      fixed: "right",
      width: "110px",
      render: (_, record) => (
        <StyledFlex className="actions">
          {/* <ActionButton
            type="detail"
            onClick={() => handleSelect(record)}
            noLabel
          /> */}

          <ActionButton
            type="edit"
            onClick={() => handleSelect(record)}
            noLabel
          />

          <ActionButton
            type="delete"
            onClick={() => deleteQuery.mutate(record)}
            itemName="common.provider"
            noLabel
          />
        </StyledFlex>
      ),
    },
  ];

  return generateColumns(props, columnsConfig);
};

export default getColumns;
